import React from 'react'
import Input from 'app/theme/forms/Input'
import { DollarSign, HelpCircle } from 'react-feather'
import Tooltip from 'app/theme/Tooltip'
import { numberWithCommas } from 'app/theme/calculator'

export default function LeadMinGuarantee(props) {
  const { minimum, data, setData, setErrors } = props

  return (
    <div>
      <div className="p-8">
        <div className="m-auto" style={{ maxWidth: 300 }}>
          <div className="flex items-center">
            <div className="relative flex flex-1 items-center">
              <DollarSign
                size={20}
                className="absolute left-0 text-gray-400"
              />
              <Input
                autoFocus
                type="number"
                value={data.min_guarantee}
                data-test-id='min_guarantee'
                placeholder="Enter amount per vendor"
                classNames={{
                  div: 'flex-1',
                  input: 'input-underline pl-6',
                }}
                onChange={min_guarantee => {
                  setErrors(null)
                  setData(prev => ({
                    ...prev,
                    min_guarantee,
                  }))
                }}
              />
            </div>
            <Tooltip content="A minimum guarantee helps vendors ensure they will cover the costs to participate in your event. A guarantee means you only pay for the difference between the guarantee amount and how much sales are generated by the vendor. Assuming sales exceed your minimum, you do not need to pay anything.">
              <div className="text-blue rounded-full p-1">
                <HelpCircle size={18} />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="text-sm text-gray-600 mt-5">
          <span>Minimum sales guarantees are standard for food trucks. </span>
          {minimum?.catering_min && (
            `A typical minimum is $${numberWithCommas(minimum.catering_min)} for meals. `
          )}
          <span>Putting in a lower minimum will likely affect the quantity and quality of vendors who will want to participate in your event. </span>
          <span>So add more to your minimum to get the best range of food trucks who want to apply!</span>
        </div>
      </div>
    </div>
  )
}
